import styled from "styled-components";
import { useState,useEffect } from "react";
import { getTokens } from "../service/main/api";
import { useUserContext } from "../context/UserContext";
import { PrimaryButton } from "./styled";
import { createWithdrawTransaction } from "../service/main/api";
// import InfoIcon from "../assets/icons/info.svg";
// import WalletIcon from "../assets/icons/wallet.svg";
import { redeemSignedClaim } from "../service/web3/redeem";
import {useLoading} from "../context/LoadingContext";
import { useToaster } from "../hooks/useToaster";



const WithdrawalModalContent = ({ closeSheet }) => {
    const { user } = useUserContext();
    const [tokenList, setTokenList] = useState([]);
    const [selectedToken, setSelectedToken] = useState(null);
    const [amount, setAmount] = useState();
    const {setIsLoading} = useLoading();
    const {showToaster} = useToaster();
    const formatNumber = (num) => {
      if(num === undefined) return "0.00";
      if(typeof num === "string") num = parseFloat
      return num.toLocaleString(undefined, {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      });
    };

    const prepareTokens = async () => {
      const res= await getTokens();
      if(res.success){
        const tokens = res.data;
        let list = [];
        tokens.forEach((token) => {
            let tokenData = {
                id: token._id,
                name: token.name,
                balance: (user.balances[token._id]) || 0,
                logo: require(`../assets/images/logo/tokens/${(token.symbol).toLowerCase()}.png`),
                symbol: token.symbol,
                balanceUSD:0,
                minimumWithdrawAmount: token.minimumWithdrawAmount,
                withdrawFee: token.withdrawFee


            };
            list.push(tokenData);
        });
        setTokenList(list);
        setSelectedToken(list[0]);
      }
  
      // console.log(user.balances)
      // console.log(tokens);
    };
    useEffect(() => {
      prepareTokens();
    }, []);
    const handlePerchandage = (percentage) => {
      let amount = selectedToken.balance * percentage;
      if(percentage == 1){
        amount = amount - selectedToken.withdrawFee;
      }
      if(selectedToken.symbol === "TON"){
        setAmount((parseFloat(amount)));
        return;
      }
      setAmount(Math.floor(amount));
    }
    const handleAmount = (e) => {
      if(e.target.value === ""){
        setAmount("");
        return;
      }
      if(selectedToken.symbol === "TON"){
        setAmount((parseFloat(e.target.value)));
        return;
      };
      setAmount(Math.floor(e.target.value));
    }
    const handleSelect = (e) => {
      const selected = tokenList.find(token => token.name === e.target.value);
      setSelectedToken(selected);
      setAmount(0);
    }
    const handleWithdraw = async () => {

      if(amount < selectedToken.minimumWithdrawAmount){
        showToaster({message: "Amount is less than minimum withdraw amount", type: "error"});
        closeSheet();
        return;
      }
      if( amount > selectedToken.balance){
        showToaster({message: "Amount is more than wallet balance", type: "error"});
        closeSheet();
        return;
      }
      if(amount <= 0){
        showToaster({message: "Amount can't be zero", type: "error"});
        closeSheet();

        return;
      }
      setIsLoading(true);
      const res = await createWithdrawTransaction({amount: amount});
      if(res?.success){
          // sign message here
          const claim = res.data;
          const signatureRes = await redeemSignedClaim(claim);
          if(!signatureRes.success){
            showToaster({message: signatureRes.message, type: "error"});
            setIsLoading(false);
            closeSheet();
            return;
          }
          closeSheet();
          showToaster({message: "Withdraw request created successfully", type: "success"});
      }else{
          closeSheet();
          showToaster({message: res.message, type: "error"});
      }
      setIsLoading(false);
      console.log("withdraw", amount, selectedToken.name);
    }
    return (
    <Container>
      <TokenSelectorContainer>
        <TokenIcon src={selectedToken?.logo}  />
        <TokenSelector onChange={handleSelect}>
          {tokenList.map((token) => (
            <option key={token.name} value={token.name}>{token.name}</option>
          ))}
        </TokenSelector>
      </TokenSelectorContainer>
      <AmountInput value={amount} onChange={handleAmount} type="number" placeholder="Amount" />
      <ButtonContainer>
        <PercentageButton onClick={()=>handlePerchandage(0.25)}>25%</PercentageButton>
        <PercentageButton onClick={()=>handlePerchandage(0.50)} >50%</PercentageButton>
        <PercentageButton onClick={()=>handlePerchandage(1)}>Max</PercentageButton>
      </ButtonContainer>
      <InfoText>Minimum {selectedToken?.name} amount: <strong>{selectedToken?.minimumWithdrawAmount}</strong></InfoText>
      <InfoText style={{marginTop:"0px"}}>Withdraw Fee: <strong>%{selectedToken?.withdrawFee * 100}</strong></InfoText>

      <PrimaryButton style={{display: "flex", alignItems:"center", justifyContent:"center"}}
      onClick={handleWithdraw}>
      Withdraw</PrimaryButton>
      <InfoText style={{marginTop:23, marginBottom:0 }}>Wallet Balance: {formatNumber(selectedToken?.balance)}</InfoText>
    </Container>
  );
};
const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 35px;
    padding-bottom: 34px;
`

const RecommendContainer = styled.div`
  background: #654DA14D;
  backdrop-filter: blur(30px);
  padding: 13px 18px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 23px
`

const TokenSelectorContainer = styled.div`
display:flex;
align-items:center;
padding: 0 16px 0 10px;
border:none;
background-color: #63636330;
backdrop-filter: blur(10px);
width: 100%;
height:42px;
border-radius: ${(props) => props.theme.borderRadius || "100px"};
`
const TokenIcon = styled.img`
width:26px;
height:26px;
margin-right: 5px
`
const TokenSelector = styled.select`
  width: 100%;
  height:100%;
  // border: 1px solid ${(props) => props.theme.colors.border || "#C3C7E6"};
  font-size: 1rem;
  color: ${(props) => props.theme.colors.text.light || "#2C2E3E"};
  outline: none;
  border:none;
  background-color:transparent;
`;

// const TokenIcon = styled.img`
//   width: 32px;
//   height: 32px;
//   margin-right: ${(props) => props.theme.spacing(1)};
// `;

const AmountInput = styled.input`
  backdrop-filter: blur(10px);
  height:42px;
  width: 100%;
  padding: ${(props) => props.theme.spacing(1)};
  font-size: 1rem;
  // border: 1px solid ${(props) => props.theme.colors.border || "#C3C7E6"};
  border-radius: ${(props) => props.theme.borderRadius || "100px"};
  margin-top: ${(props) => props.theme.spacing(2)};
  text-align: left;
  background-color: #63636330;
  color: ${(props) => props.theme.colors.text.light || "#2C2E3E"};
  padding: 0 19px;
  border:none;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${(props) => props.theme.spacing(2)};
  gap: ${(props) => props.theme.spacing(1)};
`;

const PercentageButton = styled.button`
  backdrop-filter: blur(10px);
  border: 1px solid #FFFFFF;

  padding: ${(props) => props.theme.spacing(1)} ${(props) => props.theme.spacing(2)};
  font-size: 0.9rem;
  background-color: #63636333;
  border-radius: ${(props) => props.theme.borderRadius || "100px"};
  color: ${(props) => props.theme.colors.text.light || "#2C2E3E"};
  cursor: pointer;
  width: 100%;
  height: 42px;
  &:hover {
    background-color: ${(props) => props.theme.colors.buttonHover || "#B0B8E0"};
  }
`;

const InfoText = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.colors.text.lightSecondary || "#fff"};
  margin-top: ${(props) => props.theme.spacing(2)};
  text-align: center;
  margin-bottom: ${(props) => props.theme.spacing(2)};
`;


const WalletBalance = styled.p`
  font-size: 0.9rem;
  color: ${(props) => props.theme.colors.text.lightSecondary || "#7C819A"};
  text-align: center;
  margin-top: ${(props) => props.theme.spacing(2)};
`;

export default WithdrawalModalContent;
